import { Audit } from '@ad-rendering/groundcontrol-legacy/modules/audit';
import gc from '@ad-rendering/groundcontrol-legacy/tag';

import 'intersection-observer';

Audit.init();

gc();
